<template>
    <ConfirmationForm
        :type="AssortmentType.Colocation"
        :price="monthlyPrice"
        :setup-price="setupPrice"
        :configuration="mailSummary"
        :selection="selection"
        :redirect-params="`?redirect=colocation/confirm&query=${queryParams}`"
    />
</template>

<script setup>
import ConfirmationForm from './ConfirmationForm.vue';
import { getQueryParams } from '../../../utils/windowUtils';
import { useAssortmentColocation } from '../composables/assortmentColocation';
import { AssortmentType } from '../../../types';
import { onMounted } from 'vue';
import { pushToGoogleTagManager } from '../../../utils/googleTagManagerUtils';

const props = defineProps({
    assortmentContent: { type: String, default: '' },
    assortmentNetworkContent: { type: String, default: '' },
    assortmentIpContent: { type: String, default: '' },
});

const queryParams = getQueryParams('|');
const { monthlyPrice, setupPrice, mailSummary, selection } = useAssortmentColocation(
    props.assortmentContent,
    props.assortmentNetworkContent,
    props.assortmentIpContent
);

onMounted(() => {
    pushToGoogleTagManager({
        event: `${AssortmentType.Colocation.toLowerCase()}-config-page-1-continue`,
        conversionValue: monthlyPrice.value,
    });
});
</script>
